import { render, staticRenderFns } from "./PersonItemBasic.vue?vue&type=template&id=5f1f4ea9"
import script from "./PersonItemBasic.vue?vue&type=script&lang=js"
export * from "./PersonItemBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports